// extracted by mini-css-extract-plugin
export default {"flexContainer":"TopAside_flexContainer__vv7H-"};